import React, {useEffect, useState} from 'react';
import { connect } from 'react-redux';
import { Disclosure } from '@headlessui/react';
import {Link, useLocation} from 'react-router-dom';
import logo from '../../assets/image/logo.png';
import {ChevronRightIcon} from '@heroicons/react/24/solid';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {faWhatsapp} from '@fortawesome/free-brands-svg-icons';
import {
    faCartShopping, faHeart, faSearch, faBars, faTimes,
    faHome, faUser, faTags, faFire, faBolt, faStore, faArrowLeft
} from '@fortawesome/free-solid-svg-icons';
import {motion, AnimatePresence} from 'framer-motion';
import Auth from './navbar/auth_user';
import LogoutModal from "../login/logoutMobil";

const navigation = [
    {name: 'Perfil', href: '/dashboard/perfil', icon: faUser},
    {name: 'Compras pendiente', href: '/dashboard/compras', icon: faHeart},
    {name: 'Productos comprados', href: '/dashboard/productos', icon: faTags},
];

function NavbarUser({quantity, token, user}) {
    const [isOpen, setIsOpen] = useState(false);
    const [sidebarView, setSidebarView] = useState('nav');
    const [isLogoutOpen, setIsLogoutOpen] = useState(false);
    const location = useLocation();


    useEffect(() => {
        if (!isOpen) {
            const timer = setTimeout(() => setSidebarView('nav'), 300);
            return () => clearTimeout(timer);
        }
    }, [isOpen]);

    const isActive = (url) => {
        if (url === '/') return location.pathname === '/';
        return location.pathname.startsWith(url);
    };

    const handleOpenLogout = () => {
        setIsOpen(false);
        setTimeout(() => {
            setIsLogoutOpen(true);
        }, 300);
    };



    return (
        <>


            {/* Navbar principal */}
            <Disclosure as="nav" className="bg-white shadow-md sticky top-0 z-50 transition-all duration-300">
                {({open}) => (
                    <>
                        <div className="max-w mx-auto px-0 px-sm-8 px-lg-12">
                            <div className="flex justify-between">
                                <div className="col-12 flex items-center justify-content-between flex-wrap px-4 py-3">
                                    {/* Desktop: Logo + WhatsApp */}
                                    <div className="col-4 d-none d-lg-flex items-center">
                                        <Link to={'/'}>
                                            <img src={logo} alt="Piray Market" width={160} className="ml-2"/>
                                        </Link>
                                        <a href="https://wa.me/59175071150" target="_blank" rel="noopener noreferrer"
                                           className="ml-2">
                                            <FontAwesomeIcon icon={faWhatsapp}
                                                             className="block h-7 w-7 text-white bg-brand-green hover:bg-green-500 duration-300 transition-colors rounded-full p-1 shadow-sm hover:shadow"/>
                                        </a>
                                    </div>


                                    {/* Mobile Header & Desktop Icons */}
                                    <div
                                        className="col-12 col-sm-4 py-1 py-sm-0 flex items-center justify-between sm:justify-end gap-2 sm:gap-3 w-full">
                                        <div className='d-sm-none shrink-0'>
                                            <Link to={'/'}>
                                                <img src={logo} alt="Piray Market"
                                                     className="w-[120px] sm:w-[160px] h-auto"/>
                                            </Link>
                                        </div>

                                        <div className="flex flex-row items-center gap-2 sm:gap-3 shrink-0">
                                            {/* Mobile Hamburger */}
                                            <button
                                                onClick={() => setIsOpen(true)}
                                                className='d-sm-none bg-blue-50 p-2 rounded-full text-brand-blue hover:bg-brand-blue hover:text-white transition-all duration-300 shadow-sm hover:shadow'
                                            >
                                                <FontAwesomeIcon icon={faBars} className="block h-5 w-5"/>
                                            </button>

                                            {/* Desktop Icons */}
                                            <div className="hidden sm:flex items-center gap-3">
                                                <Auth/>
                                                <Link
                                                    className='bg-blue-50 p-1.5 sm:p-2 rounded-full text-brand-blue hover:bg-brand-blue hover:text-white transition-all duration-300 shadow-sm hover:shadow'
                                                    to={'/mi/carrito'}>
                                                    <div className="relative">
                                                        <FontAwesomeIcon icon={faCartShopping}
                                                                         className="block h-5 w-5 sm:h-6 sm:w-6 rounded-full"/>
                                                        <div
                                                            className="absolute -top-4 -right-3 sm:-top-5 sm:-right-4 py-0.5 px-1.5 sm:py-1 sm:px-2 flex items-center justify-center bg-brand-orange text-white text-[10px] sm:text-xs rounded-full font-bold shadow-sm">
                                                            <span>{quantity}</span>
                                                        </div>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </Disclosure>

            {/* Mobile slide-out menu */}
            <AnimatePresence>
                {isOpen && (
                    <>
                        {/* Overlay */}
                        <motion.div
                            initial={{opacity: 0}}
                            animate={{opacity: 1}}
                            exit={{opacity: 0}}
                            onClick={() => setIsOpen(false)}
                            className="fixed inset-0 bg-black/40 backdrop-blur-sm z-[60] d-sm-none"
                        />

                        {/* Panel */}
                        <motion.div
                            initial={{x: '-100%'}}
                            animate={{x: 0}}
                            exit={{x: '-100%'}}
                            transition={{type: 'spring', damping: 25, stiffness: 300}}
                            className="fixed top-0 left-0 w-[280px] h-full bg-white shadow-2xl z-[70] flex flex-col d-sm-none overflow-hidden"
                        >
                            {/* Header */}
                            <div className="flex items-center justify-between p-4 border-b border-gray-100 shrink-0">
                                {sidebarView !== 'nav' ? (
                                    <button
                                        onClick={() => setSidebarView('nav')}
                                        className="flex items-center gap-2 text-sm font-semibold text-ecoprimary1 hover:text-brand-blue transition-colors"
                                    >
                                        <FontAwesomeIcon icon={faArrowLeft} className="text-xs"/>
                                        <span>Volver al menú</span>
                                    </button>
                                ) : (
                                    <Link to="/" onClick={() => setIsOpen(false)}>
                                        <img src={logo} alt="Mio precio" className="w-[120px] h-auto"/>
                                    </Link>
                                )}
                                <button
                                    onClick={() => setIsOpen(false)}
                                    className="p-2 rounded-full hover:bg-gray-100 transition-colors"
                                >
                                    <FontAwesomeIcon icon={faTimes} className="text-gray-500 text-lg"/>
                                </button>
                            </div>

                            {/* Content */}
                            <div className="flex-1 overflow-y-auto">
                                <AnimatePresence mode="wait">
                                    {sidebarView === 'nav' && (
                                        <motion.div
                                            key="nav"
                                            initial={{opacity: 0, x: -20}}
                                            animate={{opacity: 1, x: 0}}
                                            exit={{opacity: 0, x: -20}}
                                            transition={{duration: 0.2}}
                                            className="py-4 px-3"
                                        >
                                            <div className="space-y-1">
                                                {navigation.map((item) => (
                                                    <Link
                                                        to={item.href}
                                                        key={item.name}
                                                        onClick={() => setIsOpen(false)}
                                                        className={`
                                                            no-underline flex items-center justify-between px-4 py-3 rounded-xl text-sm font-medium transition-all duration-200
                                                            ${isActive(item.href) ? 'bg-blue-50 text-brand-blue' : 'text-gray-600 hover:text-brand-blue hover:bg-gray-50'}
                                                        `}
                                                    >
                                                        <div className="flex items-center gap-3">
                                                            <FontAwesomeIcon icon={item.icon} className="w-5"/>
                                                            <span>{item.name}</span>
                                                        </div>
                                                        {item.name === 'Carrito' && quantity > 0 && (
                                                            <span
                                                                className="bg-brand-orange text-white text-xs py-0.5 px-2 rounded-full font-bold">
                                                                {quantity}
                                                            </span>
                                                        )}
                                                    </Link>
                                                ))}

                                                <div className="my-3 border-t border-gray-100"/>

                                                {/* Account section */}
                                                <div className="px-4 py-3 bg-gray-50 rounded-xl">
                                                    <div
                                                        className="mb-2 text-xs font-semibold text-gray-400 uppercase tracking-wider">Cuenta
                                                    </div>
                                                    {token ? (
                                                        <div className="space-y-2">
                                                            <div className="flex items-center gap-3 py-2">
                                                                <div
                                                                    className="w-10 h-10 bg-ecoprimary1 rounded-full flex items-center justify-center">
                                                                    <FontAwesomeIcon icon={faUser}
                                                                                     className="text-white"/>
                                                                </div>
                                                                <div>
                                                                    <p className="text-sm font-semibold text-gray-800 mb-0">{user?.name}</p>
                                                                    <p className="text-xs text-gray-400 mb-0">{user?.email}</p>
                                                                </div>
                                                            </div>

                                                            <div className="block w-full text-center py-0.5 px-4 bg-ecoprimary1 text-white rounded-lg text-sm font-semibold no-underline transition-colors" onClick={() => handleOpenLogout()}>
                                                                Cerrar sesión
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="space-y-2">
                                                            <div className="flex items-center gap-3 py-2">
                                                                <div
                                                                    className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center">
                                                                    <FontAwesomeIcon icon={faUser}
                                                                                     className="text-gray-400"/>
                                                                </div>
                                                                <p className="text-sm text-gray-500 mb-0">Inicia sesión
                                                                    para acceder a tu cuenta</p>
                                                            </div>
                                                            <button
                                                                onClick={() => setSidebarView('login')}
                                                                className="w-full py-2.5 px-4 bg-ecoprimary1 text-white rounded-lg text-sm font-semibold hover:bg-blue-700 transition-colors"
                                                            >
                                                                Iniciar sesión
                                                            </button>
                                                            <button
                                                                onClick={() => setSidebarView('register')}
                                                                className="w-full py-2.5 px-4 bg-white border-2 border-gray-200 text-gray-700 rounded-lg text-sm font-semibold hover:border-ecoprimary1 hover:text-ecoprimary1 transition-colors"
                                                            >
                                                                Registrarse
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </motion.div>
                                    )}
                                </AnimatePresence>
                            </div>
                        </motion.div>
                    </>
                )}
            </AnimatePresence>
            <div className="opacity-0">
                <LogoutModal open={isLogoutOpen} setOpen={setIsLogoutOpen} />
            </div>
        </>
    );
}

const mapStateToProps = (state) => ({
    quantity: state.Cart.quantity,
    token: state.Auth.token,
    user: state.Auth.user,
});

export default connect(mapStateToProps, {})(NavbarUser);



